<div id="word-data-center">
    <div id="word-data-border">
        <div *ngIf="definition && (definition.noun || definition.verb)" class="word-data">
            <h2 class="data-header">Definitions</h2>
            <div class="long-list" >
                <span *ngFor="let noun of nouns">Noun: {{noun}}</span>
                <span *ngFor="let verb of verbs">Verb: {{verb}}</span>
            </div>  
        </div>
        <div *ngIf="examples && examples[0]" class="word-data">
            <h2 class="data-header">Examples</h2>
            <div class="long-list">
                <span *ngFor="let example of examples">{{example}}</span>    
            </div>
        </div>
        <div *ngIf="relatedTerms && relatedTerms[0]" class="word-data">
            <h2 class="data-header">Related Words</h2>
            <div class="list" >
                <span *ngFor="let term of relatedTerms">{{term}}</span>
            </div>
        </div>
        <div *ngIf="association && association[0]" class="word-data">
            <h2 class="data-header">Associated words</h2>
            <div class="list">
                <span *ngFor="let a of association">{{a}}</span>
            </div>
        </div>
        <div *ngIf="themes && themes[0]" class="word-data">
            <h2 class="data-header">Themes</h2>
            <div class="list">
                <span *ngFor="let theme of themes">{{theme}}</span>
            </div>
        </div>
    </div>    
</div>
